import React from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

const ErrorBoundary = (): React.JSX.Element => {
    const error = useRouteError() as any;
    let response: React.JSX.Element;

    if (isRouteErrorResponse(error)) {
        response = (
            <>
                <pre>
                    {error.status} - {error.statusText}
                </pre>
                <pre>{error.data}</pre>
            </>
        );
    } else if (error instanceof Error) {
        response = (
            <>
                <h2>{error.message}</h2>
                <pre>{error.name}</pre>
                <pre>{error.stack}</pre>
            </>
        );
    } else {
        const stackLines = (error.error.message as string).split("\n");

        response = (
            <>
                <h2>Unknown Error</h2>
                <pre>
                    {stackLines.map((line, index) => (
                        <div key={index}>{line}</div>
                    ))}
                </pre>
            </>
        );
    }

    return (
        <main>
            <section className="content errorPage">
                <h1>An error occurred!</h1>
                {response}
            </section>
        </main>
    );
};

export default ErrorBoundary;
